export const CustomerStatusCssClasses = ["danger", "success", "success", "secondary"];
export const CustomerStatusTitles = ["BANNED", "ACTIVE", "ACTIVE", "DELETED"];
export const CustomerAccStatusTitles = ["Unverfied", "Verfied", "", ""];
export const CustomerTypeCssClasses = ["success", "primary", ""];
export const CustomerTypeTitles = ["Business", "Individual", ""];
export const defaultSorted = [{ dataField: "createdAt", order: "desc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    username: "",
  },
  sortOrder: "desc", // asc||desc
  sortField: "createdAt",
  pageNumber: 1,
  pageSize: 10
};
